import React, { useEffect, useMemo } from "react";
import CustomReactTable from "../../../components/ReactTable/CustomReactTable";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  deleteCar,
  getAllCars,
  patchEditCarFormValues,
} from "../../../redux/CarsManagement/Cars/carsSlice";
import confirmAlert from "../../../helpers/ConfirmAlert";

function CarsGrid() {
  const dispatch = useDispatch();

  const { allCars, isLoading, actionsResult } = useSelector(
    (state) => state.cars
  );

  const handleEditCar = (row) => {
    dispatch(patchEditCarFormValues(row));
  };

  const handleDeleteCar = (id) => {
    confirmAlert({
      title: "حذف السيارة",
      message: "هل أنت متأكد من حذف هذه السيارة؟",
      onConfirm: () => dispatch(deleteCar(id)),
    });
  };

  useEffect(() => {
    dispatch(getAllCars());
  }, [actionsResult]);

  const glowEffect = (e, type) => {
    if (type === "enter") {
      e.currentTarget.style.boxShadow = "0 0 15px rgba(0, 123, 255, 0.9)";
      e.currentTarget.style.transform = "scale(1.08)";
      e.currentTarget.style.transition = "0.2s ease";
    } else {
      e.currentTarget.style.boxShadow = "none";
      e.currentTarget.style.transform = "scale(1)";
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "اسم السيارة",
        accessor: "nameAr",
      },
      {
        Header: "المُصنع",
        accessor: "brand.brandNameAr",
      },
      {
        Header: "النوع",
        accessor: "brand.nameAr",
      },
      {
        Header: "سنة الصنع",
        accessor: "manufacture_year",
      },

      // Categories
      {
        Header: "الفئات",
        Cell: ({ row }) => {
          const isEnabled = row.original.allowCategories;

          return (
            <div className="uk-flex uk-flex-center">
              <NavLink
                to={isEnabled ? "/Cars/Categories" : "#"}
                state={
                  isEnabled
                    ? {
                        carId: row.original.id,
                        carName: row.original.nameAr,
                      }
                    : null
                }
                className={`uk-button uk-button-primary uk-button-small uk-border-pill ${
                  !isEnabled ? "uk-disabled" : ""
                }`}
                style={{
                  pointerEvents: isEnabled ? "auto" : "none",
                  opacity: isEnabled ? 1 : 0.5,
                  cursor: isEnabled ? "pointer" : "not-allowed",
                }}
                onMouseEnter={(e) =>
                  isEnabled && glowEffect(e, "enter")
                }
                onMouseLeave={(e) =>
                  isEnabled && glowEffect(e, "leave")
                }
              >
                <span uk-icon="tag" className="uk-margin-small-left"></span>
                الفئات
              </NavLink>
            </div>
          );
        },
      },

      // Images
      {
        Header: "الصور",
        Cell: ({ row }) => (
          <div className="uk-flex uk-flex-center">
            <NavLink
              to="/Cars/CarImages"
              state={{
                carId: row.original.id,
                carName: row.original.nameAr,
              }}
              className="uk-button uk-button-secondary uk-button-small uk-border-pill"
              onMouseEnter={(e) => glowEffect(e, "enter")}
              onMouseLeave={(e) => glowEffect(e, "leave")}
            >
              <span uk-icon="image" className="uk-margin-small-left"></span>
              الصور
            </NavLink>
          </div>
        ),
      },

      {
        Header: "الحالة",
        accessor: "status",
        Cell: ({ row }) =>
          row.original.status ? (
            <span className="uk-text-success" uk-icon="check"></span>
          ) : (
            <span className="uk-text-danger" uk-icon="close"></span>
          ),
      },
      {
        Header: "الترتيب",
        accessor: "order",
      },
      {
        Header: "الإجراء",
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="actions uk-flex uk-flex-center uk-flex-middle">
            <NavLink
              to="/Cars/EditCar"
              uk-tooltip="تعديل"
              className="uk-icon-button"
              uk-icon="pencil"
              onClick={() => handleEditCar(row.original)}
            ></NavLink>

            <button
              uk-tooltip="حذف"
              className="uk-icon-button uk-margin-small-right"
              uk-icon="trash"
              onClick={() => handleDeleteCar(row.original.id)}
            ></button>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <CustomReactTable data={allCars} columns={columns} isLoading={isLoading} />
  );
}

export default CarsGrid;